import type { TOC } from '@ember/component/template-only';
import { PrismBanner } from '@mylighthouse/prism-ember';

interface HotelBenchmarkInsightTopBannerSignature {
  Args: {
    bannerContent: unknown;
    bannerStyle: unknown;
    closeBanner: unknown;
    dataTestId: unknown;
    hasCta?: boolean;
    icon?: string;
    primaryAction?: unknown;
  };
}

const HotelBenchmarkInsightTopBanner = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="w-full" data-test-id={{@dataTestId}}>
    <PrismBanner
      @bannerMessage={{@bannerContent.message}}
      @bannerStyle={{@bannerStyle}}
      @bannerTitle={{@bannerContent.title}}
      @close={{@closeBanner}}
      @hasCta={{@hasCta}}
      @icon={{@icon}}
      @position="top"
      @primaryAction={{@primaryAction}}
    />
  </div>
</template> satisfies TOC<HotelBenchmarkInsightTopBannerSignature>;

export default HotelBenchmarkInsightTopBanner;
